module.exports = __webpack_public_path__ + "img/horizontal_6_5_7016.84fac275.png";